'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var MenuItem = _interopDefault(require('@material-ui/core/MenuItem'));
var KeyboardArrowDownIcon = _interopDefault(require('@material-ui/icons/KeyboardArrowDown'));
var Validator = require('../../validation/Validator/Validator.js');
var styledComponents = require('./styled-components.js');

var SelectWithTopLabel = function (props) {
    var menuItems = props.menuItems, _a = props.title, title = _a === void 0 ? '' : _a, defaultValue = props.defaultValue, reporter = props.reporter, Icon = props.Icon, error = props.error, _b = props.disabled, disabledInput = _b === void 0 ? false : _b, _c = props.placeholder, placeholder = _c === void 0 ? '' : _c, _d = props.validators, validators = _d === void 0 ? [] : _d, reportErrors = props.reportErrors, _e = props.activateValidation, activateValidation = _e === void 0 ? false : _e;
    var _f = React.useState(false), shouldValidate = _f[0], setShouldValidate = _f[1];
    // This ensures that a placeholder is always added if specified
    if (placeholder && placeholder !== '') {
        // This ensures that the placeholder is only added once
        if ((menuItems.length && menuItems[0].value !== 'xxxx') || !menuItems.length) {
            menuItems.unshift({
                value: 'xxxx',
                display: placeholder,
                disabled: true,
            });
        }
    }
    var _g = React.useState(defaultValue || (menuItems[0] ? menuItems[0].value : '')), param = _g[0], setParam = _g[1];
    var _h = React.useState(true), isInitialLoad = _h[0], setIsInitialLoad = _h[1];
    var handleChange = function (event) {
        setParam(event.target.value);
    };
    React.useEffect(function () {
        if (defaultValue !== param) {
            setParam(defaultValue || (menuItems[0] ? menuItems[0].value : ''));
        }
    }, [defaultValue]);
    React.useEffect(function () {
        if (isInitialLoad) {
            setIsInitialLoad(false);
            return;
        }
        var res = menuItems.find(function (item) {
            if (typeof item.value === 'object') {
                var x = item.value;
                return String(x.id) === param;
            }
            return false;
        });
        if (res) {
            reporter(res.value);
        }
        else {
            reporter(param);
        }
        // do not add dependencies here.
    }, [param]);
    var getStringValueFromObject = function (value) {
        if (typeof value === 'object') {
            return String(value.id);
        }
        if (!value) {
            return '';
        }
        return String(value);
    };
    var remappedMenuItems = menuItems.map(function (item) {
        return {
            value: getStringValueFromObject(item.value),
            display: item.display,
            disabled: !!item.disabled,
        };
    });
    var validationEnabled = validators.length > 0;
    var handleBlur = function () {
        setShouldValidate(validationEnabled);
    };
    return (React__default.createElement(Validator, { validators: validators, data: param, shouldValidate: activateValidation || shouldValidate, reportErrors: reportErrors, renderErrors: true, renderChild: function (isError) {
            return (React__default.createElement(styledComponents.Main, null,
                typeof title === 'string' && title.length > 0 && (React__default.createElement(styledComponents.StyledInputLabel, null, title)),
                typeof title !== 'string' && title,
                React__default.createElement(styledComponents.StyledSelect, { error: isError || error, value: param, onChange: handleChange, onBlur: handleBlur, onClose: handleBlur, input: React__default.createElement(styledComponents.StyledInput, { error: error, disabled: disabledInput }), IconComponent: Icon || KeyboardArrowDownIcon, inputProps: {
                        'data-testid': 'select-input',
                    }, MenuProps: {
                        anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'left',
                        },
                        transformOrigin: {
                            vertical: 'top',
                            horizontal: 'left',
                        },
                        getContentAnchorEl: null,
                        marginThreshold: 0,
                    }, "data-testid": 'select-parent' }, remappedMenuItems.map(function (_a) {
                    var value = _a.value, display = _a.display, disabled = _a.disabled;
                    return (React__default.createElement(MenuItem, { key: value, value: value, disabled: disabled },
                        React__default.createElement("div", { className: disabled ? 'disabled' : '' }, display)));
                }))));
        } }));
};

module.exports = SelectWithTopLabel;
